(() => {
  'use strict';
  // Presentation only. theme.js owns variants, real Shopify prices, cart and checkout.
  let teardown = () => {};
  function initializeVisual() {
  teardown();
  const root = document.querySelector('[data-detalora-visual]');
  if (!root) return;
  let config;
  try { config = JSON.parse(root.querySelector('[data-visual-config]').textContent); } catch (_) { return; }
  const lifecycle = new AbortController();
  const observers = [];
  const listen = (target, event, handler) => target?.addEventListener(event, handler, {signal: lifecycle.signal});
  const hero = root.querySelector('#hero-video');
  const proofs = [...root.querySelectorAll('.dv-proof')];
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const demoVisibility = new Map();
  let demoSide = 'right', lastOrderSide = '', heroVisible = false, heroKey = '';
  const currentModel = () => root.querySelector('[data-model-button][aria-pressed="true"]')?.dataset.modelButton || 'e90';
  const currentPanel = () => root.querySelector('[data-product-panel="' + currentModel() + '"]');
  const currentRadio = () => currentPanel()?.querySelector('[data-variant-radio]:checked');
  const currentProof = () => currentPanel()?.querySelector('.dv-proof');
  function label(model, side) { return 'BMW ' + model.toUpperCase() + ' · ' + config.strings[side]; }
  function attemptHero() {
    const proof = currentProof(), video = proof?.querySelector('video');
    if (!hero || reduce.matches || !heroVisible || document.hidden || (proof?.open && demoVisibility.get(video))) return;
    hero.muted = true;
    hero.play().catch(() => {});
  }
  function attemptDemo(proof) {
    const video = proof?.querySelector('video'), error = proof?.querySelector('[data-video-error]');
    if (!video || proof !== currentProof() || !proof.open || !demoVisibility.get(video) || reduce.matches || document.hidden) return;
    video.muted = true;
    video.play().then(() => { if (error) error.hidden = true; }).catch(() => {
      // Native controls are a fallback only when the browser blocks autoplay.
      video.controls = true;
      if (error) error.hidden = false;
    });
  }
  function updateVideos() {
    const model = currentModel(), side = currentRadio()?.dataset.kind || '';
    if (side === 'left' || side === 'right') demoSide = side;
    else if (side !== lastOrderSide && !side) demoSide = 'right';
    lastOrderSide = side;
    const clip = config.clips?.[model]?.[demoSide];
    if (!clip || !hero) return;
    const key = model + '/' + demoSide, videoLabel = label(model, demoSide);
    if (heroKey !== key) {
      hero.pause(); hero.poster = clip.poster; hero.src = clip.src; hero.muted = true; heroKey = key;
    }
    root.querySelector('[data-hero-label]').textContent = videoLabel;
    for (const proof of proofs) {
      const video = proof.querySelector('video');
      const active = proof === currentProof();
      if (!active) { video.pause(); continue; }
      proof.querySelector('[data-proof-subtitle]').textContent = videoLabel;
      proof.querySelector('[data-demo-label]').textContent = videoLabel;
      proof.querySelector('.dv-demo-tabs').hidden = side === 'left' || side === 'right';
      proof.querySelectorAll('[data-demo-side]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.demoSide === demoSide)));
      video.poster = clip.poster; video.controls = reduce.matches;
      video.setAttribute('aria-label', videoLabel);
      if (proof.open && video.dataset.clipKey !== key) {
        video.pause(); video.src = clip.src; video.muted = true; video.dataset.clipKey = key;
        proof.querySelector('[data-video-error]').hidden = true;
      }
      if (proof.open) attemptDemo(proof);
    }
    attemptHero();
  }
  function sync() {
    const model = currentModel();
    root.querySelector('[data-fit-codes]').textContent = model === 'e90' ? 'E90 / E91 / E92 / E93' : 'E60 / E61';
    for (const panel of root.querySelectorAll('[data-product-panel]')) {
      const radio = panel.querySelector('[data-variant-radio]:checked'), kind = radio?.dataset.kind;
      const photos = panel.querySelector('[data-selection-photos]');
      if (photos) photos.hidden = !radio;
      panel.querySelectorAll('[data-selection-image]').forEach(image => image.hidden = !radio || (kind !== 'pair' && kind !== image.dataset.selectionImage));
      const included = panel.querySelector('[data-included]');
      if (included) included.textContent = !radio ? '' : kind === 'pair' ? config.strings.pair : config.strings.unit;
    }
    updateVideos();
  }
  listen(document, 'detalora:selectionchange', sync);
  proofs.forEach(proof => {
    const video = proof.querySelector('video');
    listen(proof, 'toggle', () => { if (proof.open) { updateVideos(); attemptDemo(proof); } else { video.pause(); attemptHero(); } });
    listen(video, 'play', () => { hero.pause(); proofs.forEach(other => { if (other !== proof) other.querySelector('video').pause(); }); });
    listen(video, 'error', () => { proof.querySelector('[data-video-error]').hidden = false; video.controls = true; });
    proof.querySelectorAll('[data-demo-side]').forEach(button => listen(button, 'click', () => {
      // A demonstration tab does not change the purchased variant.
      demoSide = button.dataset.demoSide; updateVideos();
    }));
  });
  listen(hero, 'play', () => proofs.forEach(proof => proof.querySelector('video').pause()));
  if ('IntersectionObserver' in window) {
    if (hero) {
      const heroObserver = new IntersectionObserver(entries => {
      heroVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= .35;
      if (heroVisible) attemptHero(); else hero.pause();
      }, {threshold: .35});
      heroObserver.observe(hero); observers.push(heroObserver);
    }
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      demoVisibility.set(entry.target, entry.isIntersecting && entry.intersectionRatio >= .2);
      if (demoVisibility.get(entry.target)) attemptDemo(entry.target.closest('.dv-proof')); else entry.target.pause();
    }), {threshold: .2});
    proofs.forEach(proof => observer.observe(proof.querySelector('video')));
    observers.push(observer);
  } else {
    heroVisible = true; proofs.forEach(proof => demoVisibility.set(proof.querySelector('video'), true));
  }
  listen(document, 'visibilitychange', () => {
    if (document.hidden) { hero?.pause(); proofs.forEach(proof => proof.querySelector('video').pause()); }
    else { attemptHero(); attemptDemo(currentProof()); }
  });
  listen(reduce, 'change', () => {
    proofs.forEach(proof => { const video = proof.querySelector('video'); video.controls = reduce.matches; if (reduce.matches) video.pause(); });
    if (reduce.matches) hero?.pause(); else { attemptHero(); attemptDemo(currentProof()); }
  });
  listen(window, 'pagehide', () => { hero?.pause(); proofs.forEach(proof => proof.querySelector('video').pause()); });
  listen(window, 'pageshow', sync);
  teardown = () => {
    lifecycle.abort(); observers.forEach(observer => observer.disconnect());
    hero?.pause(); proofs.forEach(proof => proof.querySelector('video').pause());
    teardown = () => {};
  };
  sync();
  }
  initializeVisual();
  document.addEventListener('shopify:section:load', initializeVisual);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target?.querySelector('[data-detalora-visual]') || event.target?.matches('[data-detalora-visual]')) teardown();
  });
})();

